import React, { useState, useRef, useEffect } from 'react';
import './ReminderBell.css';

function formatWhen(dateStr) {
  const d = new Date(dateStr.replace(' ', 'T'));
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

function ReminderBell({ overdue, upcoming, markDone, snooze }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const count = overdue.length + upcoming.length;
  const items = [...overdue, ...upcoming];

  return (
    <div className="rb-wrap" ref={ref}>
      <button className="rb-bell" onClick={() => setOpen((o) => !o)} title="Follow-up reminders">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {count > 0 && <span className="rb-badge">{count}</span>}
      </button>

      {open && (
        <div className="rb-dropdown">
          <div className="rb-dropdown__header">Follow-up Reminders</div>
          {items.length === 0 ? (
            <div className="rb-empty">No pending follow-ups 🎉</div>
          ) : (
            <div className="rb-list">
              {items.map((inq) => {
                const isOverdue = overdue.some((o) => o.id === inq.id);
                return (
                  <div key={inq.id} className={`rb-item ${isOverdue ? 'rb-item--overdue' : ''}`}>
                    <div className="rb-item__top">
                      <strong>{inq.name}</strong>
                      <span className={`rb-tag ${isOverdue ? 'rb-tag--overdue' : 'rb-tag--upcoming'}`}>
                        {isOverdue ? 'Overdue' : 'Upcoming'}
                      </span>
                    </div>
                    {inq.follow_up_note && <p className="rb-item__note">{inq.follow_up_note}</p>}
                    <div className="rb-item__meta">{formatWhen(inq.follow_up_at)}</div>
                    <div className="rb-item__actions">
                      <a href={`/admin/inquiries?open=${inq.id}`} className="rb-btn rb-btn--link">View</a>
                      <button className="rb-btn" onClick={() => snooze(inq.id, 60)}>Snooze 1h</button>
                      <button className="rb-btn rb-btn--done" onClick={() => markDone(inq.id)}>Done</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ReminderBell;